<template>
  <v-container id="pedidos" tag="section">
    <base-v-component heading="Pedidos " />
    <base-material-card
      color="indigo"
      icon="mdi-account-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="pedidos"
        :loading="loading"
        :search="search"
        :must-sort="true"
        sort-by="fecha"
        :sort-desc="true"
      >
        <template v-slot:item.acciones="{ item }">
          <v-row>
            <!--<v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  small
                  v-on="on"
                  @click="goView(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver pedido {{item.id}}</span>
            </v-tooltip>-->
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto } from "@/utils/utils.js";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Pedido Restaurante",
          value: "numPedidoRest",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Origen",
          value: "origen",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Forma pago",
          value: "formaPago",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "precioTotal",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "restauranteMostrar",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      //pedidosNegocio: state => state.pedidos.pedidosArray
    }),
    ...mapGetters({
      pedidosBruto: "pedidos/getPedidosListado",
    }),
    pedidos() {
      var devolver = [];
      console.log(this.pedidosBruto);
      this.pedidosBruto.forEach((p) => {
        let aux = p;
        aux.fecha = moment(aux.fechaServidor.toDate()).format(
          "DD-MM-YYYY HH:mm"
        );
        aux.origen = p.estado == "tpv-realizando" ? "TPV" : "ONLINE"; // mejorar
        aux.modo = p.modo;
        aux.restauranteMostrar =
          aux.copyNegocio.nombre +
          " " +
          (aux.copyRest ? aux.copyRest.nombre : "");
        aux.precioTotal = mostrarMoneda(aux.precioTotal);
        aux.formaPago = idToTexto(aux.forma_pago);
        devolver.push(aux);
      });
      return devolver;
    },
  },
  methods: {
    reload() {
      this.getPedidos();
    },
    getPedidos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("pedidos/getPedidosNegocio").finally(() => {
        _vm.loading = false;
      });
    },

    goView(item) {
      console.log(item);
      let str = "/admin/pedidos/view/" + item.id;
      this.$router.push(str);
    },
  },
  mounted() {
    this.$store.dispatch("pedidos/setRangoDefecto");
  },
};
</script>

<style>
</style>